import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=d19ddbb8&scoped=true"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"
import style0 from "./complain.vue?vue&type=style&index=0&id=d19ddbb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19ddbb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d19ddbb8')) {
      api.createRecord('d19ddbb8', component.options)
    } else {
      api.reload('d19ddbb8', component.options)
    }
    module.hot.accept("./complain.vue?vue&type=template&id=d19ddbb8&scoped=true", function () {
      api.rerender('d19ddbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/complain.vue"
export default component.exports